const STORAGE_KEY = 'aurelqen_consent_v1';

export const DEFAULT_CONSENT = {
  necessary: true,
  functionality_storage: true,
  analytics_storage: false,
  ad_storage: false,
  ad_user_data: false,
  ad_personalization: false,
  personalization_storage: false,
  timestamp: null,
};

export function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function hasConsentChoice() {
  return !!readConsent();
}

export function persistConsent(consent) {
  const payload = { ...DEFAULT_CONSENT, ...consent, timestamp: Date.now() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {}
  return payload;
}

function toState(v) {
  return v ? 'granted' : 'denied';
}

export function updateConsent(consent) {
  const payload = persistConsent(consent);
  if (typeof window === 'undefined') return payload;

  window.dataLayer = window.dataLayer || [];
  const gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  gtag('consent', 'update', {
    ad_storage: toState(payload.ad_storage),
    ad_user_data: toState(payload.ad_user_data),
    ad_personalization: toState(payload.ad_personalization),
    analytics_storage: toState(payload.analytics_storage),
    functionality_storage: toState(payload.functionality_storage),
    personalization_storage: toState(payload.personalization_storage),
    security_storage: 'granted',
  });

  window.dataLayer.push({ event: 'cookie_consent_update' });
  return payload;
}

export function acceptAll() {
  return updateConsent({
    functionality_storage: true,
    analytics_storage: true,
    ad_storage: true,
    ad_user_data: true,
    ad_personalization: true,
    personalization_storage: true,
  });
}

export function rejectAll() {
  return updateConsent({
    functionality_storage: true,
    analytics_storage: false,
    ad_storage: false,
    ad_user_data: false,
    ad_personalization: false,
    personalization_storage: false,
  });
}
